(ns pfo.document.model
  (:require
    [ajax.formats :refer [raw-response-format]]
    [pfo.api :as api]
    [pfo.util :as util]))

(defn document-key [document] (str "document" (:id document)))

(defn year-and-quarter [period] (let [[year quarter] (util/split-string (str period) "-")] {:year year :quarter quarter}))
(defn get-filter-api-params [filter-map]
  (merge {:collection_id (:collection-id filter-map)
          :include_subcollections (:include-subcollections filter-map)
          :include_linked_to_other_parents (:include-linked-to-other-parents filter-map)
          :collection_type_id (into [] (mapcat identity (:collection-types filter-map)))
          :collection_type_exclude (:collection-types-exclude filter-map)
          :category_id (into [] (mapcat identity (:categories filter-map)))
          :category_exclude (:categories-exclude filter-map)
          :creator_user_id (vec (:creator-users filter-map))
          :creator_user_exclude (:creator-users-exclude filter-map)
          :created_at_period (:created-at-period filter-map)
          :created_at_period_exclude (:created-at-period-exclude filter-map)
          :period_exclude (:period-exclude filter-map)}
         (year-and-quarter (:period filter-map))))

(defn document-list [_ page order filter-map link-parent]
  (api/ajaxp (str "/documents/?" (->
                                   (merge
                                     {:page page
                                      :order order
                                      :parent_type (:parent-type link-parent)
                                      :parent_id (:parent-id link-parent)
                                      :parent_complete_by (:complete-by link-parent)}
                                     (get-filter-api-params filter-map))
                                   util/remove-nil-values
                                   util/make-params))
    {}))

(defn collection-assignable-document-list [options page order filter-map link-parent]
  (api/ajaxp (str "/collection/" (:collection-id filter-map) "/document/?"
               (->
                 (merge
                   {:paginate (if (:paginate options) "yes" "no")
                    :changes (util/base64-url-marshal {:current (into [] (:current options))
                                                       :deleted (into [] (:deleted options))})
                    :page page
                    :order order
                    :parent_type (:parent-type link-parent)
                    :parent_id (:parent-id link-parent)
                    :parent_complete_by (:complete-by link-parent)
                    :image (:image options)}
                   (get-filter-api-params filter-map))
                 util/remove-nil-values
                 util/make-params)) {}))

(defn document-details [id]
  (api/ajaxp (str "/documents/" id "/") {}))

(defn document-type [document]
  (case (:doc_type document)
    "d" :document
    "n" :note
    "b" :boir
    nil))

(def signature-status-pending "p")
(def signature-status-completed "c")

(def signature-providers
  {"dropbox_sign" "Dropbox Sign"})

(defn file-upload [file]
  (let [form-data (doto
                    (js/FormData.)
                    (.append "file" file))]
    (api/ajaxp "/file/upload/"
              {:method :post
               :body form-data})))

(defn make-document-params [parent [group-id collection-ids category-id upload-id aname ext-ref year month day quarter body main-collection-id]]
  (util/make-params
    (util/remove-nil-values
      (merge
        {:upload_id upload-id
         :name aname
         :ext_ref ext-ref
         :year year
         :month month
         :day day
         :quarter quarter
         :category_id category-id
         :body body
         :group_id group-id
         :collection_id collection-ids
         :main_collection_id main-collection-id}
        parent))))

(defn document-add [parent & form-data]
  (api/ajaxp "/documents/"
             {:method :post
              :body (make-document-params parent form-data)}))

(defn document-update [document-id parent & form-data]
  (api/ajaxp (str "/documents/" document-id "/")
             {:method :post
              :body (make-document-params parent form-data)}))

(defn document-delete [document-id]
  (api/ajaxp (str "/documents/" document-id "/")
             {:method :delete}))

(defn document-filter-dates [collection-id include-subcollections]
  (api/ajaxp "/filter/documents/dates/" {:params (util/remove-nil-values {:collection_id collection-id
                                                                          :include_subcollections include-subcollections})}))

(defn document-filter-categories [collection-id include-subcollections]
  (api/ajaxp "/filter/documents/categories/" {:params (util/remove-nil-values {:collection_id collection-id
                                                                          :include_subcollections include-subcollections})}))

(defn document-filter-collection-types [collection-id include-subcollections]
  (api/ajaxp "/filter/documents/collection_types/" {:params (util/remove-nil-values {:collection_id collection-id
                                                                          :include_subcollections include-subcollections})}))

(defn document-comments [document-id]
  (api/ajaxp (str "/documents/" document-id "/comments/") {}))

(defn document-add-comment [document-id conversation-id note subject body notify-user-ids notify-cc-user-ids include-body allow-inbox-reply revised-comment-id]
  (api/ajaxp (str "/documents/" document-id "/comments/")
             {:method :post
              :body (util/make-params
                     (util/remove-nil-values {:conversation_id conversation-id
                                              :body body
                                              :note note
                                              :subject subject
                                              :notify_user_id notify-user-ids
                                              :notify_cc_user_id notify-cc-user-ids
                                              :include_body include-body
                                              :allow_inbox_reply allow-inbox-reply
                                              :revised_comment_id revised-comment-id}))}))

(defn document-update-comment [document-id comment-id subject body notify-user-ids notify-cc-user-ids include-body allow-inbox-reply]
  (api/ajaxp (str "/documents/" document-id "/comments/" comment-id "/")
             {:method :post
              :body (util/make-params
                     (util/remove-nil-values {:subject subject
                                              :body body
                                              :notify_user_id notify-user-ids
                                              :notify_cc_user_id notify-cc-user-ids
                                              :include_body include-body
                                              :allow_inbox_reply allow-inbox-reply}))}))

(defn document-delete-comment [document-id comment-id notify-user-ids]
  (api/ajaxp (str "/documents/" document-id "/comments/" comment-id "/?" (util/make-params
                      (util/remove-nil-values {:notify_user_id notify-user-ids})))
             {:method :delete
              :response-format (raw-response-format)}))

(defn document-comments-summary [document-id]
  (api/ajaxp (str "/documents/" document-id "/summary/comments/") {}))

(defn document-summary [document-id]
  (api/ajaxp (str "/documents/" document-id "/summary/") {}))

(defn add-link [filter-params parent-type parent-id parent-complete-by child-type child-id select]
  (api/ajaxp "/links/document/"
             {:method :post
              :body (util/make-params
                      (util/remove-nil-values (merge filter-params
                                                     {:parent_type parent-type
                                                      :parent_id parent-id
                                                      :parent_complete_by parent-complete-by
                                                      :child_type child-type
                                                      :child_id child-id
                                                      :select select})))}))
